import { useEffect, useState } from "react";
import styles from "./productCard.module.scss";
import { Products } from "@/common/entities/product/Product";
import { FaCheckSquare } from "react-icons/fa";

interface CompareToggleButtonProps {
    isSelected?: boolean;
    onToggle?: (product: Products, isSelected: boolean) => void;
    product?: Products;
}

const CompareToggleButton = ({ isSelected = false, onToggle, product }: CompareToggleButtonProps) => {
    const [isSquareFilled, setIsSquareFilled] = useState(isSelected);

    useEffect(() => {
        setIsSquareFilled(isSelected);
    }, [isSelected]);

    const toggleSquare = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        const newValue = !isSquareFilled;
        setIsSquareFilled(newValue);

        if (onToggle && product) {
            onToggle(product, newValue);
        }
    };

    return (
        <div className={styles.squareClassCircle}>
            <FaCheckSquare
                aria-hidden={true}
                className={isSquareFilled ? styles.filledSquare : styles.emptySquare}
                onClick={toggleSquare}
            />
        </div>
    );
};

export default CompareToggleButton;
